import React from "react";
import { PageLayout } from "../components/PageLayout";
import { Products } from "../features/products/Products";
import { HomeCarousel } from "../components/HomeCarousel";
import { Box, Typography } from "@mui/material";

export const ProductsPage: React.FC = () => {
  return <PageLayout>
    <HomeCarousel />
    <Box
      sx={{
        textAlign: 'center',
        padding: '20px',
        backgroundColor: '#f8f8f8',
        margin: '0',
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontSize: '28px',
          fontWeight: 'bold',
          color: '#001d3d',
          marginBottom: '2px',
          marginTop: '1px',
        }}
      >
        Trending Now
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: '16px',
          color: '#333',
          maxWidth: '800px',
          margin: '0 auto',
          lineHeight: 1.4,
        }}
      >
        Find out the most popular products and devices in eShop
      </Typography>
    </Box>
    <Products />
  </PageLayout>;
};